import React from "react";
import { View } from 'react-native'
import { ModalStyles } from 'styles/components/atoms/Modal'
import * as Animatable from 'react-native-animatable'
import { colorList } from 'utils/colors'
import IconBackground from 'components/atoms/IconBackground'
import { layoutStyles } from 'styles/layout'

const Modal = ({ containerStyle = {}, testID = null, animationOnMount = null, children }) => {
	
	const viewStyle = [
		ModalStyles.container,
		containerStyle
	];
	
	const content = [];
	content.push(
		<View
			style={ ModalStyles.background }>
			
			<IconBackground
				containerStyle={ layoutStyles.flexOne }
				iconImageStyle={ layoutStyles.flexOne }
				opacity={ 0.5 }
				linearGradientColours={ [
					colorList.ORANGE.primary,
					colorList.ORANGE.primary,
					colorList.ORANGE.light,
					colorList.WHITE.primary
				] }
			/>
		</View>
	);
	
	if( !animationOnMount ){
		return (
			<View
				style={ dynamicContainerStyle }
				testID={ testID }>
				
				{ content }
				{ children }
			</View>
		);
	}
	
	return (
		<Animatable.View
			animation={ animationOnMount }
			duration={ 1000 }
			key={ 'animatableModal' }
			style={ viewStyle }>
			
			<View
				testID={ testID }
				style={ viewStyle }>
				
				{ content }
				{ children }
			</View>
		</Animatable.View>
	);
};

export default Modal;
